import { getPublicUrl } from '@/common';

export const usePublicUrl = <T extends string | undefined>(path: MaybeRefOrGetter<T>, opts?: { fragment?: string }) => {
    const url = computed((): T => {
        const url = new URL(getPublicUrl());
        const thePath = toValue(path);
        if (thePath == null) {
            return undefined as T;
        }
        url.pathname = thePath;
        if (opts?.fragment) {
            url.hash = opts.fragment;
            url.search = '';
        }
        return url.toString() as T;
    });

    return { url };
};
